
export function getUrl()
{
    //return "http://localhost:3005/legalback" // Para backeend local


    return "https://boxy.currenmexico.com/legalback"

}
